export const newFHIRResourceTemplate = Object.freeze({
    label: 'New FHIR Resource',
    groupParams: [],
    urlPrefix: '',
});
//# sourceMappingURL=consts.js.map